import BossModel from "@/models/BossModel";
import User from "@/models/User/User";
import Product from "@/models/Product/Product";

export default class Notice extends BossModel {
    /**
     *
     * @type {string}
     */
    static apiUrl = "product/notice";

    /**
     *
     * @type {string}
     */
    static entity = "productNotices";

    static fields() {
        return {
            id: this.number(null).nullable(),
            product_id: this.number(null).nullable(),
            user_id: this.number(null).nullable(),
            start_date_at: this.attr(null),
            end_date_at: this.attr(null),
            message: this.attr(null),
            is_active: this.boolean(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            deleted_at: this.attr(null),
            product: this.belongsTo(Product, "product_id"),
            user: this.belongsTo(User, "user_id"),
        };
    }

    /**
     *
     * @returns {boolean|*}
     */
    User() {
        return this.getRelated("user");
    }
}
